/* eslint-disable react-hooks/exhaustive-deps */

import constate from 'constate'
import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

export const SUB_NAV_EXPANDED_WIDTH = 240
export const SUB_NAV_COLLAPSED_WIDTH = 54

const navigationCollapsedRoutes = ['ai/chat', 'editor']

export const useSubNavigation = () => {
  const [isSubNavOpen, setIsSubNavOpen] = useState(false)
  const [isSubNavCollapsed, setIsSubNavCollapsed] = useState(true)
  const location = useLocation()

  const isCollapsedEnabled = useMemo(() => {
    const isCollapsed = navigationCollapsedRoutes.find((path) => location.pathname.includes(path))
    return !!isCollapsed
  }, [location])

  useEffect(() => {
    if (isCollapsedEnabled) {
      setIsSubNavCollapsed(true)
    } else {
      setIsSubNavCollapsed(false)
    }
  }, [isCollapsedEnabled])

  useEffect(() => {
    if (location.pathname.includes('project')) {
      setIsSubNavOpen(true)
    } else {
      setIsSubNavOpen(false)
    }
  }, [location])

  return { isSubNavOpen, setIsSubNavOpen, isSubNavCollapsed, setIsSubNavCollapsed, isCollapsedEnabled }
}

const [SubNavigationContainer, useSubNavigationContext] = constate(useSubNavigation)

export { SubNavigationContainer, useSubNavigationContext }
